import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import injectSaga from 'utils/injectSaga';
import Lightbox from 'react-image-lightbox';
import { Button, Radio, Icon } from 'antd';
import saga from './saga';
import { makeSelectOfferId } from 'containers/CatalogEdit/selectors';
import { featureAllowed } from 'containers/App/selectors';
import { makeSelectImages, makeSelectCar, makeSelectIsLoading, makeSelectDownloadIsLoading } from '../CarSelector/selectors';
import { withCarSelectorReducer } from '../CarSelector/withReducer';
import { uploadRequest, downloadImages, setMain, deleteImage, deleteAll } from './actions';
import { default as Loader } from 'components/Loader/';
import 'react-image-lightbox/style.css';
import './styles.scss';
import 'antComponentsStyle';

class CarImages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false,
      whichImagesSelected: null,
      customMainSelected: null,
    };

    this.inputOpenFileRef = React.createRef();
    this.handleOnAddClick = this.handleOnAddClick.bind(this);
    this.onWhichImagesChange = this.onWhichImagesChange.bind(this);
    this.onCustomMainChange = this.onCustomMainChange.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
    // this.handleOnDownloadClick = this.handleOnDownloadClick.bind(this);
  }

  componentDidUpdate = prevProps => {
    if (prevProps !== this.props) {
      let { photos } = this.props
      photos = photos.toJS ? photos.toJS() : photos;

      if (photos && photos.custom && photos.custom.length) {
        const mainImage = photos.custom.find(img => img.type === 'MAIN') || {};

        this.setState({
          whichImagesSelected: 'custom',
          customMainSelected: this.state.customMainSelected || mainImage.id || null
        })
      } else {
        this.setState({
          whichImagesSelected: 'default',
        })
      }
    }
  }

  handleOnMoreImageClick = (photos, index) => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
      photoIndex:
        photos !== undefined ? index : prevState.photoIndex,
    }));
  };

  handleOnAddClick() {
    this.inputOpenFileRef.current.click();
  }

  onChangeFile(e) {
    const files = e.target.files || e.dataTransfer.files;
    this.props.upload(files, this.props.car.id, this.props.offerId);
  }

  onWhichImagesChange = ({target:{value}}) => {
    if (value === 'default' && !confirm('Attenzione: se confermi questa scelta le tue immagini verranno cancellate.')) {
      return false;
    } else if (value === 'custom' && !confirm('Confermi di essere il titolare dei diritti dei contenuti caricati, o di avere il permesso da parte del legittimo titolare.')) {
      return false;
    }

    if (value === 'default') {
      this.props.deleteAll(this.props.car.id)
    }

    this.setState({whichImagesSelected: value})
  }

  onCustomMainChange = ({target:{value}}) => {
    this.props.setMain(value)
    this.setState({customMainSelected: value})
  }

  onDeleteClick = imgId => {
    if (confirm('Sicuro di voler cancellare questa immagine?')) {
      this.props.deleteImage(imgId);
    }
  }

  handleOnDownloadClick = imagesType => {
    this.props.download(this.props.car.id, this.props.car.brand.data.value, this.props.car.modello, imagesType);
  }

  render() {
    const { photoIndex, isOpen, whichImagesSelected, customMainSelected } = this.state;
    const { photos, loading, downloadLoading, car, featureAllowed } = this.props;

    return (
      <div id="CarImages" className="position-relative">
        <Loader loading={loading} />
        {featureAllowed('car-custom-images') &&
          <>
          <div>
            <Radio
              name="whichImages"
              value="custom"
              onChange={this.onWhichImagesChange}
              checked={whichImagesSelected === 'custom'}
              disabled={typeof car.id === 'undefined'}
            >
              Voglio caricare le mie immagini
            </Radio>
            <Button
                className="pull-right"
                icon={downloadLoading ? 'loading' : 'download'}
                size="small"
                type="link"
                onClick={() => this.handleOnDownloadClick('custom')}
                disabled={downloadLoading || !photos.custom || !photos.custom.length}
              >
                Scarica immagini
              </Button>
          </div>
          <div className={classnames({
            'inline-profile-tiles': true,
            'mt-3': true,
            'ghost': whichImagesSelected !== 'custom'
            })}>
            <Row className="no-gutters">
              {isOpen && whichImagesSelected === 'custom' && photos.custom && (
                <Lightbox
                  mainSrc={photos.custom[photoIndex].source}
                  nextSrc={photos.custom[(photoIndex + 1) % photos.custom.length].source}
                  prevSrc={
                    photos.custom[(photoIndex + photos.custom.length - 1) % photos.custom.length]
                      .source
                  }
                  onCloseRequest={this.handleOnMoreImageClick}
                  onMovePrevRequest={() =>
                    this.setState({
                      photoIndex:
                        (photoIndex + photos.custom.length - 1) % photos.custom.length,
                    })
                  }
                  onMoveNextRequest={() =>
                    this.setState({
                      photoIndex: (photoIndex + 1) % photos.custom.length,
                    })
                  }
                />
              )}
              <Col md={3} sm={3} className="no-gutters">
                <div
                  className="profile-tile profile-tile-inlined"
                  style={{ cursor: 'pointer', height: '100%' }}
                >
                  <a
                    className="profile-tile-box faded"
                    style={{ padding: '3rem 0', height: '100%' }}
                    onClick={this.handleOnAddClick}
                  >
                    <div className="pt-new-icon">
                      <i className="os-icon os-icon-plus" />
                    </div>
                    <div className="pt-user-name">
                      Aggiungi
                      <br /> Immagine
                    </div>
                  </a>
                  <input
                    ref={this.inputOpenFileRef}
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={this.onChangeFile.bind(this)}
                    style={{ display: 'none' }}
                  />
                </div>
              </Col>
              {photos.custom && photos.custom.map((item, key) => (
                <Col md={3} sm={3} className="no-gutters" key={key}>
                  <div className="card">
                    <img
                      className="card-img-top"
                      src={item.source}
                      onClick={() => this.handleOnMoreImageClick(photos.custom, key)}
                      title={item.description}
                      alt={'Immagine '+item.description}
                    />
                    <span style={{position: 'absolute', right: '5px', bottom: '5px'}} title="Scegli come prima immagine">
                      <Radio.Group size="small" buttonStyle="solid" name="main" onChange={this.onCustomMainChange} value={customMainSelected}>
                        <Radio.Button value={item.id}>
                          Copertina
                        </Radio.Button>
                      </Radio.Group>
                    </span>
                    <span style={{position: 'absolute', right: '5px', top: '5px'}} title="Elimina">
                      <Button icon="delete" type="danger" size="small" onClick={() => this.onDeleteClick(item.id)} />
                    </span>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
          </>
        }
        {featureAllowed('car-custom-images') &&
          <div className="mt-4">
            <Radio
              name="whichImages"
              value="default"
              onChange={this.onWhichImagesChange}
              checked={whichImagesSelected === 'default'}
            >
              Voglio usare le immagini in archivio
            </Radio>
              <Button
                className="pull-right"
                icon={downloadLoading ? 'loading' : 'download'}
                size="small"
                type="link"
                onClick={() => this.handleOnDownloadClick('default')}
                disabled={downloadLoading}
              >
                Scarica immagini
              </Button>
          </div>
        }
        <div className={classnames({
          'inline-profile-tiles': true,
          'mt-3': true,
          'ghost': whichImagesSelected !== 'default'
          })}>
          <Row className="no-gutters">
            {isOpen && whichImagesSelected === 'default' && photos.default && (
              <Lightbox
                mainSrc={photos.default[photoIndex].source}
                nextSrc={photos.default[(photoIndex + 1) % photos.default.length].source}
                prevSrc={
                  photos.default[(photoIndex + photos.default.length - 1) % photos.default.length]
                    .source
                }
                onCloseRequest={this.handleOnMoreImageClick}
                onMovePrevRequest={() =>
                  this.setState({
                    photoIndex:
                      (photoIndex + photos.default.length - 1) % photos.default.length,
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    photoIndex: (photoIndex + 1) % photos.default.length,
                  })
                }
              />
            )}
            {photos.default && photos.default.map((item, key) => (
              <Col md={3} sm={3} className="no-gutters" key={key}>
                <div className="card">
                  <img
                    className="card-img-top"
                    src={item.source}
                    onClick={() => this.handleOnMoreImageClick(photos.default, key)}
                    title={item.description}
                    alt={'Immagine '+item.description}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    );
  }
}

CarImages.propTypes = {
  upload: PropTypes.func.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    upload: (files, car, offer) => dispatch(uploadRequest(files, car, offer)),
    download: (carId, carBrand, carModel, imagesType) => dispatch(downloadImages(carId, carBrand, carModel, imagesType)),
    setMain: imageId => dispatch(setMain(imageId)),
    deleteImage: imageId => dispatch(deleteImage(imageId)),
    deleteAll: carId => dispatch(deleteAll(carId)),
  };
}

const mapStateToProps = createStructuredSelector({
  photos: makeSelectImages(),
  car: makeSelectCar(),
  offerId: makeSelectOfferId(),
  loading: makeSelectIsLoading(),
  downloadLoading: makeSelectDownloadIsLoading(),
  featureAllowed: (state, featureSlug) => featureAllowed(state, featureSlug),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withSaga = injectSaga({ key: 'carImages', saga });

export default compose(
  withCarSelectorReducer,
  withSaga,
  withConnect,
)(CarImages);
